import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import {Drawer, DrawerContent, DrawerItem, DrawerNavigation} from '@progress/kendo-react-layout';
import {chevronDoubleRightIcon, menuIcon} from "@progress/kendo-svg-icons";
import {SvgIconButton} from "../../../../base/Button/SvgIconButton.jsx";

export const MainSideDrawer = ({ navigationItems }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [expanded, setExpanded] = useState(false);

    const handleToggle = () => {
        setExpanded(prevState => !prevState);
    };

    const handleSelect = (ev) => {
        setExpanded(false);

        // Navigate to the selected route
        const selectedItem = navigationItems[ev.itemIndex];
        if (selectedItem && selectedItem.route) {
            navigate(selectedItem.route);
        }
    };

    return (
        <div>
            <Drawer
                expanded={expanded}
                position="end"
                mode="overlay"
                animation={{ duration: 400 }}
                onOverlayClick={handleToggle}
                onSelect={(ev) => {
                    // Check if it's the close button (first item)
                    if (ev.itemIndex === 0) {
                        handleToggle();
                    } else {
                        // Adjust index for navigation items (subtract 2 for close button + separator)
                        const adjustedEvent = {
                            ...ev,
                            itemIndex: ev.itemIndex - 2
                        };
                        handleSelect(adjustedEvent);
                    }
                }}
            >
                <DrawerNavigation>
                    <DrawerItem svgIcon={chevronDoubleRightIcon} onClick={handleToggle}/>
                    <DrawerItem separator={true} />
                    {
                        ...navigationItems.map((props, index) => (
                            <DrawerItem
                                {...props}
                                selected={location.pathname === props.route}
                                onClick={() => handleSelect({...props, itemIndex: index})}
                            />
                        ))
                    }

                </DrawerNavigation>
                <DrawerContent>
                    {/*The toggle for the drawer*/}
                    <SvgIconButton onClick={handleToggle} svgIcon={menuIcon} />
                </DrawerContent>
            </Drawer>

            <Drawer>
            </Drawer>
        </div>
    );
};